define.alias("shared/components/shared/addon-details-card/upcoming-plan", "calendar/components/shared/addon-details-card/upcoming-plan");